import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import clsx from 'clsx';
import styles from './MetricCard.module.scss';

export interface MetricCardProps {
  /** Metric label */
  label: string;
  /** Formatted metric value */
  value: string;
  /** Trend percentage (positive = up, negative = down) */
  trend?: number;
  /** Trend period label (e.g. "vs last week") */
  trendLabel?: string;
  /** Icon to display */
  icon?: React.ReactNode;
  className?: string;
}

export function MetricCard({
  label,
  value,
  trend,
  trendLabel,
  icon,
  className,
}: MetricCardProps) {
  const trendDirection = trend === undefined ? undefined : trend > 0 ? 'up' : trend < 0 ? 'down' : 'flat';

  return (
    <div className={clsx(styles.card, className)}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        {icon && <span className={styles.icon}>{icon}</span>}
      </div>
      <div className={styles.value}>{value}</div>
      {trend !== undefined && (
        <div className={clsx(styles.trend, trendDirection && styles[trendDirection])}>
          {trendDirection === 'up' && <TrendingUp size={14} />}
          {trendDirection === 'down' && <TrendingDown size={14} />}
          {trendDirection === 'flat' && <Minus size={14} />}
          <span>
            {trend > 0 ? '+' : ''}
            {trend.toFixed(1)}%
          </span>
          {trendLabel && <span className={styles.trendLabel}>{trendLabel}</span>}
        </div>
      )}
    </div>
  );
}
